// Generated from Visit's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type VisitCollectionFilterGroups
  = | {
    readonly user: Iri | Iri[]
    readonly stared?: boolean | boolean[]
  }

export const visitCollectionFilterMapping: FilterDefinitionMapping<VisitCollectionFilterGroups> = {
  user: 'user',
  stared: 'stared',
}

export type VisitCollectionSort = never
